// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2oW47","footerContent":"footer_footerContent__2mREe","contact":"footer_contact__yIhVd"};